export default __webpack_public_path__ + "static/media/ic_xvs_96.402ed65e.svg";